import PropTypes from "prop-types";
import React from "react";

import styles from "v2/styles";

const StickyFooter = (props) => {
  const style = {
    borderTop: styles.BORDER,
    bottom: 0,
    height: "50px",
    lineHeight: "50px",
    overflow: "hidden",
    position: "fixed",
    width: "100vw",
    ...props.style,
  };
  return (
    <div style={style}>
      <div className={props.className}>{props.children}</div>
    </div>
  );
};

StickyFooter.defaultProps = {
  className: "row",
  style: {},
};
StickyFooter.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default StickyFooter;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/StickyFooter.js
 **/